import { questionText, SLOT, type Question } from "../game/questions/question";
import type { Feedback } from "../game/round";

interface Props {
  question: Question;
  input: string;
  feedback: Feedback | null;
  /** When set, the question is a button that reads it aloud again. */
  onHear?: (() => void) | undefined;
}

/** The question with the answer slot wherever it falls: 7 + [ ] = 12. */
export function QuestionView({ question, input, feedback, onHear }: Props) {
  const className =
    "question display" +
    (question.tokens.length > 5 ? " long" : "") +
    (feedback ? ` ${feedback.kind}` : "");
  const label = `${questionText(question.tokens, "blank")}. Your answer: ${input || "blank"}`;
  const body = question.tokens.map((t, i) =>
    t === SLOT ? (
      <span key={i} className="ans">
        {input || " "}
      </span>
    ) : (
      <span key={i}>{t}</span>
    ),
  );
  return (
    <>
      <div className="visually-hidden" aria-live="polite">
        {label}
      </div>
      {onHear ? (
        <button
          type="button"
          className={className}
          aria-label={`${label}. Tap to hear it again.`}
          onClick={onHear}
        >
          {body}
        </button>
      ) : (
        <div className={className} aria-hidden="true">
          {body}
        </div>
      )}
    </>
  );
}
